module.exports = __webpack_public_path__ + "assets/sounds/boat-harbor-ambience.mp3";